import {
  getSemanticColor,
  IBasicStyledProps,
  SemanticColorKey,
  theme,
} from '@notino/react-styleguide';

import { styled } from '@linaria/react';

interface IProgressProps extends IBasicStyledProps {
  heightInPx?: number;
}

export const Progress = styled.div<IProgressProps>`
  height: ${(props: IProgressProps) =>
    props.heightInPx ? props.heightInPx : 8}px;
  background: ${theme.color.background.tertiary};
  position: relative;
  border-radius: 10rem;
  overflow: hidden;
`;

interface IBarProps extends IProgressProps {
  lineWidth: number;
  color?: SemanticColorKey;
  animationDuration?: number;
}
export const Bar = styled.div<IBarProps>`
  width: ${(props) => `${props.lineWidth}%`};
  height: ${(props) => (props.heightInPx ? props.heightInPx : 8)}px;
  background: ${(props) =>
    props.color
      ? getSemanticColor(props.color)
      : theme.color.background.inverse};
  transition: ${(props) =>
      props.animationDuration ? props.animationDuration : 0.2}s
    ease;
`;

export const Segments = styled.div`
  display: flex;
  position: absolute;
  height: 100%;
  width: 100%;
  line-height: 0;
`;

interface ISegmentProps {
  selectable: boolean;
}
export const Segment = styled.div<ISegmentProps>`
  width: 20%;
  height: 100%;
  cursor: ${(props) => (props.selectable ? 'pointer' : 'auto')};

  &:not(:last-child) {
    border-right: 2px solid ${theme.color.common.white};
  }
`;
